export default __webpack_public_path__ + "static/media/image7.41d2b294.png";